// src/components/AppFooter/AppFooter.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER_NOTICE } from '../../constants/DISCLAIMERS';
import styles from './AppFooter.module.scss';

const AppFooter: React.FC = () => {
  return (
    <footer className={styles.footer} role="contentinfo">
      <span className={styles.notice}>{FOOTER_NOTICE}</span>
      <nav className={styles.links} aria-label="Legal">
        <Link to="/legal/terms" className={styles.link}>Terms</Link>
        <span className={styles.dot} aria-hidden="true">·</span>
        <Link to="/legal/disclaimer" className={styles.link}>Disclaimer</Link>
        <span className={styles.dot} aria-hidden="true">·</span>
        <Link to="/legal/privacy" className={styles.link}>Privacy</Link>
      </nav>
    </footer>
  );
};

export default AppFooter;